import KeenSlider from 'keen-slider';

const initOrganizationSlider = (root) => {
  const track = root.querySelector('.keen-slider');
  const prevButton = root.querySelector('[data-slider-prev]');
  const nextButton = root.querySelector('[data-slider-next]');
  const counters = root.querySelectorAll('[data-step-count]');

  if (!track) {
    return;
  }

  const totalSlides = track.querySelectorAll('.keen-slider__slide').length;

  const renderState = (slider) => {
    if (!slider) {
      return;
    }

    const current = slider.track.details.rel;
    const total = slider.track.details.slides.length;

    root.dataset.currentStep = String(current + 1);
    root.dataset.totalSteps = String(total);

    counters.forEach((counter) => {
      counter.textContent = `${current + 1} de ${total} passos`;
    });

    if (prevButton) {
      prevButton.disabled = current <= 0;
    }

    if (nextButton) {
      nextButton.disabled = current >= total - 1;
    }
  };

  if (totalSlides <= 1) {
    root.dataset.currentStep = '1';
    root.dataset.totalSteps = String(totalSlides || 1);

    counters.forEach((counter) => {
      counter.textContent = `1 de ${totalSlides || 1} passos`;
    });

    if (prevButton) {
      prevButton.disabled = true;
    }

    if (nextButton) {
      nextButton.disabled = true;
    }

    return;
  }

  const slider = new KeenSlider(track, {
    loop: false,
    drag: true,
    slides: {
      perView: 1,
      spacing: 0,
    },
    created(instance) {
      renderState(instance);
    },
    slideChanged(instance) {
      renderState(instance);
    },
  });

  if (prevButton) {
    prevButton.addEventListener('click', () => {
      slider.prev();
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', () => {
      slider.next();
    });
  }
};

const bootstrapOrganizationSliders = () => {
  const sliders = document.querySelectorAll('[data-organization-slider]');

  if (!sliders.length) {
    return;
  }

  sliders.forEach((sliderRoot) => {
    initOrganizationSlider(sliderRoot);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapOrganizationSliders);
} else {
  bootstrapOrganizationSliders();
}
